import React from 'react'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('❌ ErrorBoundary caught:', error)
    console.error('Component stack:', info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 max-w-xl mx-auto mt-10">
          <div className="glass-card p-6">
            <h2 className="text-lg font-bold text-red-400 mb-3">⚠️ Ошибка рендера</h2>
            <pre className="text-sm text-gray-400 whitespace-pre-wrap break-all">
              {this.state.error?.message}
            </pre>
            <pre className="text-xs text-gray-600 mt-2 whitespace-pre-wrap">
              {this.state.error?.stack?.split('\n').slice(1, 4).join('\n')}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 rounded-lg bg-indigo-500/20 text-indigo-400 text-sm hover:bg-indigo-500/30 transition-colors"
            >
              Перезагрузить страницу
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
